import { Link } from "react-router-dom";
import { Instagram, Linkedin, Mail, MessageCircle } from "lucide-react";
import BrandMark from "./BrandMark";
import NewsletterForm from "./NewsletterForm";
import { SITE } from "@/lib/siteConfig";

export default function Footer() {
  const year = new Date().getFullYear();
  const waLink = `https://wa.me/${SITE.whatsappNumber}?text=${encodeURIComponent(SITE.whatsappMessage)}`;
  return (
    <footer data-testid="global-footer" className="bg-paper border-t border-clay/60 mt-16">
      <div className="container-narrow py-14 sm:py-18">
        <div className="grid grid-cols-1 md:grid-cols-12 gap-10">
          <div className="md:col-span-5">
            <BrandMark />
            <p className="mt-4 text-ink-muted max-w-md leading-[1.75] text-sm sm:text-base">
              A practice-oriented psychology program — training, field work, and supervision.
              Built on 8 years of Therapist Tribe.
            </p>
            <div className="mt-5 flex items-center gap-3">
              <a
                href={SITE.socials.instagram}
                target="_blank"
                rel="noreferrer"
                aria-label="Instagram"
                data-testid="footer-instagram-link"
                className="p-2 rounded-full bg-[rgba(200,106,74,0.08)] hover:bg-[rgba(200,106,74,0.18)] text-terracotta transition-colors focus-ring"
              >
                <Instagram className="w-5 h-5" />
              </a>
              <a
                href={SITE.socials.linkedin}
                target="_blank"
                rel="noreferrer"
                aria-label="LinkedIn"
                data-testid="footer-linkedin-link"
                className="p-2 rounded-full bg-[rgba(126,155,134,0.16)] hover:bg-[rgba(126,155,134,0.28)] text-moss transition-colors focus-ring"
              >
                <Linkedin className="w-5 h-5" />
              </a>
              <a
                href={`mailto:${SITE.email}`}
                aria-label="Email"
                data-testid="footer-email-link"
                className="p-2 rounded-full bg-[rgba(74,63,57,0.06)] hover:bg-[rgba(74,63,57,0.12)] text-ink transition-colors focus-ring"
              >
                <Mail className="w-5 h-5" />
              </a>
              <a
                href={waLink}
                target="_blank"
                rel="noreferrer"
                aria-label="WhatsApp"
                data-testid="footer-whatsapp-link"
                className="p-2 rounded-full bg-[#25D366]/15 hover:bg-[#25D366]/25 text-[#1f8d4a] transition-colors focus-ring"
              >
                <MessageCircle className="w-5 h-5" />
              </a>
            </div>
          </div>

          <div className="md:col-span-3">
            <h4 className="text-xs uppercase tracking-[0.18em] text-ink-muted mb-4">Explore</h4>
            <ul className="space-y-2 text-sm">
              <li><Link to="/" className="hover:text-terracotta">Home</Link></li>
              <li><Link to="/about" className="hover:text-terracotta">About</Link></li>
              <li><Link to="/course" className="hover:text-terracotta">Foundation Track</Link></li>
              <li><Link to="/practice-track" className="hover:text-terracotta">Advanced Practice Track</Link></li>
              <li><Link to="/pro-bono" className="hover:text-terracotta">Pro-Bono Therapy</Link></li>
              <li><Link to="/contact" className="hover:text-terracotta">Contact</Link></li>
            </ul>
          </div>

          <div className="md:col-span-4">
            <h4 className="text-xs uppercase tracking-[0.18em] text-ink-muted mb-4">Stay in touch</h4>
            <p className="text-sm text-ink-muted mb-3">
              Soft, occasional notes on mental health, programs, and community.
            </p>
            <NewsletterForm />
          </div>
        </div>

        <div className="mt-12 pt-6 border-t border-clay/60 flex flex-col sm:flex-row items-start sm:items-center justify-between gap-3 text-xs text-ink-muted">
          <div>© {year} The Human Work Project. All rights reserved.</div>
          <div className="flex items-center gap-4">
            <span>{SITE.domain}</span>
            <span className="hidden sm:inline">·</span>
            <a href={`mailto:${SITE.email}`} className="hover:text-terracotta">{SITE.email}</a>
          </div>
        </div>
      </div>
    </footer>
  );
}
